import React, { useContext } from 'react'
import {
  faChartLine,
  faBuilding,
  faFlag,
  faIdCard,
  faDownload,
  faTachometerAlt,
  faScroll,
  faFileUpload,
  faComments
} from '@fortawesome/free-solid-svg-icons'
import SidebarLink from './sidebar-link'
import UserContext from '../context/user-context'
import { isAssistantEnabled, isAssistantUser } from '../ask/access'
import { useSidebar } from './sidebar-context'

function Sidebar() {
  const user = useContext(UserContext)
  const { isCollapsed, mobileOpen, closeMobile, isMobile } = useSidebar()
  const sectionAbbreviations = user?.section_abbreviations || []
  const canUpload = sectionAbbreviations.includes('AP') || sectionAbbreviations.includes('PC')
  const canAsk = isAssistantUser(user) && isAssistantEnabled(user)

  // On desktop the sidebar is rendered inline (icon-only when collapsed).
  // On mobile it becomes an offcanvas drawer toggled by the navbar hamburger.
  const navClasses = [
    'sidebar',
    'bg-white',
    isCollapsed ? 'sidebar-collapsed' : '',
    isMobile ? 'sidebar-mobile' : '',
    isMobile && mobileOpen ? 'sidebar-mobile-open' : ''
  ]
    .filter(Boolean)
    .join(' ')

  const handleNavigate = isMobile ? closeMobile : undefined

  return (
    <>
      {isMobile && mobileOpen && (
        <div
          className="sidebar-backdrop"
          role="presentation"
          onClick={closeMobile}
        />
      )}
      <nav className={navClasses} aria-label="Main navigation">
        <div className="sidebar-sticky">
          <ul className="nav flex-column mt-2">
            <SidebarLink
              path={'dashboards'}
              url="dashboards"
              title="Views"
              icon={faChartLine}
              onNavigate={handleNavigate}
            />

            {canAsk && (
              <SidebarLink
                path={'ask'}
                url="ask"
                title="Assistant"
                icon={faComments}
                onNavigate={handleNavigate}
              />
            )}

            <SidebarLink
              path={'analytics'}
              url="analytics"
              title="Analytics"
              icon={faFlag}
              onNavigate={handleNavigate}
            />

            <SidebarLink
              path={'monitoring'}
              url="monitoring"
              title="Monitoring"
              icon={faTachometerAlt}
              onNavigate={handleNavigate}
            />

            <SidebarLink
              path={'vendors'}
              url="vendors"
              title="Vendors"
              icon={faBuilding}
              onNavigate={handleNavigate}
            />

            <SidebarLink
              path={'employees'}
              url="employees"
              title="Employees"
              icon={faIdCard}
              onNavigate={handleNavigate}
            />

            <SidebarLink
              path={'policies'}
              url={'policies'}
              title={'Policies'}
              icon={faScroll}
              onNavigate={handleNavigate}
            />

            {canUpload && (
              <SidebarLink
                path={'upload'}
                url={'upload'}
                title={'Upload'}
                icon={faFileUpload}
                onNavigate={handleNavigate}
              />
            )}

            <SidebarLink
              path={'exports'}
              url={'exports'}
              title={'Exports'}
              icon={faDownload}
              onNavigate={handleNavigate}
            />
          </ul>
        </div>
      </nav>
    </>
  )
}

export default Sidebar
